module.exports = __webpack_public_path__ + "static/media/banner_MP_420.52be6f61.jpg";